<template>
    <div class="p-sticky">
        <div class="progress" :class="{'justify-content-end': !$store.state.is_horizontal}">
            <div class="progress-bar progress-bar-striped progress-bar-animated"
                :class="{
                    'bg-danger': value < 99,
                    'bg-success': value >= 99,
                }"
                role="progressbar"
                :aria-valuenow="value"
                :aria-valuemin="0"
                :aria-valuemax="100"
                :style="'width:' + value + '%'">
                <span class="sr-only">{{value}}% Complete</span>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.p-sticky {
    position: fixed;
    z-index: 99;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 5px;
    background-color: rgba(255, 255, 255, 0.5);
    box-shadow: 0 0 20px rgba(255, 255, 255, 0.5);
    .progress {
        background: transparent;
        z-index: 99;
        margin: 0;
        height: 5px;
    }
}
</style>

<script>
export default {
    props: {
        value: {
            type: Number,
            default: 0
        }
    },
}
</script>